import Item from "./Item";
import CompanionMaterialDetailItem from "./CompanionMaterialDetailItem";

class CompanionMaterialItem {
    private readonly _name: string;
    private readonly _companionMaterialDetailItems: Array<CompanionMaterialDetailItem> = new Array<CompanionMaterialDetailItem>();

    constructor(name: string) {
        this._name = name;
    }

    private _item!: Item;

    get item(): Item {
        return this._item;
    }

    set item(value: Item) {
        this._item = value;
    }

    get name(): string {
        return this._name;
    }

    get companionMaterialDetailItems(): Array<CompanionMaterialDetailItem> {
        return this._companionMaterialDetailItems;
    }

    addCompanionMaterialDetailItem(companionMaterialDetailItem: CompanionMaterialDetailItem) {
        this._companionMaterialDetailItems.push(companionMaterialDetailItem);
    }
}

export default CompanionMaterialItem;
